import Layout from '../../pages/layout'
import { DecodeHtml } from '../../utils/decodeHtml'
import { retrunAssets } from '../../utils/getAssets'
import Header from '../../utils/header'

const Elevate = ({ data }) => {
  const title = data?.title
  const bg =
    data?.backgroundImage != null
      ? retrunAssets(data?.backgroundImage[0]?.url)
      : ''

  const elevateIntroTitle = data?.elevateIntroTitle
  const elevateIntroInfo = data?.elevateIntroInfo?.markup
  const elevateObjectiveTitle = data?.elevateObjectiveTitle
  const elevateObjectiveContents = data?.elevateObjectiveContents?.markup

  return (
    <Layout title={title} bg={bg}>
      <div className='flex flex-col gap-5 mb-10'>
        <Header text={elevateIntroTitle} />
        {DecodeHtml({ html: elevateIntroInfo })}
      </div>
      <div className='flex flex-col gap-5 mb-10'>
        <Header text={elevateObjectiveTitle} />
        {DecodeHtml({ html: elevateObjectiveContents })}
      </div>
    </Layout>
  )
}

export default Elevate
